export function getColorPayment(name: string) {
    let color = 'gray'
    switch (name) {
        case 'Efectivo':
            color = 'green'
            break
        case 'Tarjeta':
            color = 'blackAlpha'
            break
        case 'Transferencia':
            color = 'blue'
            break
        case 'Yape':
            color = 'purple'
            break
        case 'Plin':
            color = 'blue'
            break
        case 'BCP':
            color = 'blue'
            break
        case 'Interbank':
            color = 'green'
            break
        case 'BBVA':
            color = 'teal'
            break
        case 'Scotiabank':
            color = 'red'
            break
    }
    return color
}
